<div class="link-list-container {{class}}">
  <div class="headline" *ngIf="component.title">
    <kion-headline-tag
      [title]="component.title"
      [titleSize]="component.titleSize"
    ></kion-headline-tag>
  </div>
  <div class="links" *ngIf="lazyLoadedComponents$ | async as components">
    <div class="link" *ngFor="let component of components">
      <kion-link
        [linkRef]="component"
        [icon]="component.icon"
        [fakeLink]="component.typeCode === cookieLink"
        (clicked)="handleClick(component)"
      ></kion-link>
    </div>
  </div>
</div>
